<template>
  <div
    class="flex w-full"
  >
    <google-map
      ref="mapRef"
      class="w-full aspect-square"
      :center="center"
      :gesture-handling="disabled ? 'none' : 'auto'"
      :zoom-control="!disabled"
      :class="[
        {'aspect-square': disabled}, 
        {'aspect-video': !disabled},
        { 'filter grayscale': loadingData }
      ]"
    >
      <slot />
    </google-map>
  </div>
</template>

<script setup lang="ts">
import {computed, ref} from "vue";
import GoogleMap from "@/core/components/google-map/GoogleMap.vue";
import {useSystemStore} from "@/stores/system.store";

const {loadingData = false, disabled = false} = defineProps<{ loadingData?: boolean, disabled?: boolean }>();

const {environment} = useSystemStore();
const mapRef = ref<InstanceType<typeof GoogleMap>>();

const entityAddress = computed(() => {
    return environment?.entity.address;
});

const center = computed(() => {
    if (entityAddress.value && entityAddress.value?.latitude && entityAddress.value?.longitude) {
        return {
            lat: entityAddress.value.latitude,
            lng: entityAddress.value.longitude
        };
    } else {
        return {lat: 48.856613, lng: 2.352222};
    }
});

const fitMapToBounds = (bounds: { lat: number; lng: number }[], padding: number | null = null) => {
    if (mapRef.value) {
        mapRef.value.fitBounds(bounds, padding);
    }
};

defineExpose({fitMapToBounds});
</script>
